import React from 'react';
import { Button } from './ui/Button';

interface Props {
  status: string; dirty: boolean; savedAt: string | null; error: string;
  recovery: { updatedAt: string } | null; ready: boolean;
  restore: () => void; discardRecovery: () => Promise<void>; retry: () => Promise<void>;
  children?: React.ReactNode;
}
export default function EditorSaveBar(props: Props) {
  const date = props.savedAt ? new Date(props.savedAt).toLocaleString('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'short', timeStyle: 'short' }) : '';
  return <section aria-label="Speicherstatus" className="sticky top-16 z-20 mb-6 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    {props.recovery ? <div className="mb-4 rounded-lg bg-blue-50 p-4">
      <h2 className="font-semibold text-blue-900">Gesicherten Bearbeitungsstand fortsetzen</h2>
      <p className="mt-1 text-sm text-blue-800">Ein Stand vom {date} ist vorhanden. Du kannst ihn wiederherstellen oder verwerfen.</p>
      <div className="mt-3 flex flex-wrap gap-3"><Button onClick={props.restore}>Wiederherstellen</Button>
        <Button variant="outline" onClick={() => void props.discardRecovery()}>Verwerfen</Button></div>
    </div> : null}
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div role="status" aria-live="polite" className="text-sm text-gray-700">
        {props.status === 'loading' ? 'Bearbeitungsstand wird geladen …' : props.error ? 'Automatische Sicherung fehlgeschlagen' : props.status === 'saving' ? 'Wird automatisch gesichert …' : props.dirty ? 'Änderungen werden automatisch gesichert …' : props.savedAt ? `Bearbeitungsstand gesichert · ${date}` : 'Automatische Sicherung ist bereit'}
        <p className="mt-1 text-xs text-gray-500">Private Sicherung ohne Einreichung. Noch nicht hochgeladene Dateien müssen erneut ausgewählt werden.</p>
      </div>
      <div className="flex shrink-0 flex-wrap gap-3 [&_button]:whitespace-nowrap">{props.children}</div>
    </div>
    {props.error && <div role="alert" className="mt-3 rounded-lg bg-red-50 p-3 text-sm text-red-800">{props.error}
      <Button variant="outline" size="sm" className="ml-3" onClick={() => void props.retry().catch(() => undefined)}>Erneut versuchen</Button>
    </div>}
  </section>;
}
